/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Search_No_ResultsInputs */

const en_read_along_search_no_results = /** @type {(inputs: Read_Along_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0 results`)
};

const es_read_along_search_no_results = /** @type {(inputs: Read_Along_Search_No_ResultsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`0 resultados`)
};

/**
* | output |
* | --- |
* | "0 results" |
*
* @param {Read_Along_Search_No_ResultsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_search_no_results = /** @type {((inputs?: Read_Along_Search_No_ResultsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Search_No_ResultsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_search_no_results(inputs)
	return en_read_along_search_no_results(inputs)
});